import { css, useTheme } from '@emotion/react';
import styled from '@emotion/styled';
import { useRouter } from 'next/router';
import React, { useEffect } from 'react';

import { Box, Flex, Grid, Text } from '~/components/blocks';
import { useOpenMedixsPatientDialog } from '~/components/pages/Patient/use-open_medixs_patient_dialog';
import { usePlanFeature } from '~/hooks/use-plan-feature';

import { AllPatientList } from './AllPatientList';
import { Header } from './Header';
import { NewPatientDrawer } from './NewPatientDrawer';
import { NewPatientFromCheckinEntryDrawer } from './NewPatientFromCheckinEntryDrawer';
import { PatientPagination } from './PatientPagination';

const Main = styled(Grid)(({ theme }) =>
  css({
    height: '100%',
    gridTemplateRows: 'min-content 1fr min-content',
    gridTemplateColumns: '1fr',
    [`@media ${theme.mediaQueries.tablet}`]: {
      padding: `${theme.space.m} ${theme.space.l}`,
    },
  }),
);

export const Patient = () => {
  const theme = useTheme();
  const router = useRouter();
  const { loading, hasEnabledFeature: hasEnabledFollowup } = usePlanFeature('followup');
  const patientCode = router.query['patientCode'] as string | undefined;
  const eventId = router.query['eventId'] ? Number(router.query['eventId']) : undefined;
  const pharmacyId = router.query['pharmacyId'] as string | undefined;
  const recommendationPresetCode = router.query['recommendationPresetCode'] as string | undefined;
  const { open } = useOpenMedixsPatientDialog(eventId, recommendationPresetCode);

  useEffect(() => {
    (async () => {
      if (patientCode && pharmacyId && hasEnabledFollowup) {
        await open(patientCode, pharmacyId);
      }
    })();
  }, [open, patientCode, pharmacyId, router, hasEnabledFollowup]);

  if (loading) return null;
  if (!hasEnabledFollowup) {
    return (
      <Flex
        width="100%"
        height="100%"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        padding={theme.space.xl}
      >
        <Text textAlign="center" fontWeight="bold" size="xl" block>
          服薬フォローアップ機能は
          <br />
          現在ご利用いただけません
        </Text>
      </Flex>
    );
  }

  return (
    <>
      <Main>
        <Header />
        <AllPatientList />
        <Box paddingY={theme.space.l}>
          <PatientPagination />
        </Box>
      </Main>
      <NewPatientDrawer />
      <NewPatientFromCheckinEntryDrawer />
    </>
  );
};
